module.exports = __webpack_public_path__ + "static/media/idea.caa4356a.svg";